<template>
  <v-card class="card-border">
    <v-card-text>
      <v-data-table ref="dataTable" :headers="headers" :items="getDataTable" :search="search">
        <template v-slot:top>
          <v-row dense>
            <v-col cols="12" sm="12" md="4">
              <v-text-field v-model="search" label="Procurar..." prepend-inner-icon="mdi-magnify" />
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.action="{ item, index }">
          <v-tooltip v-if="$ability.can('Editar','Retencao')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogFormRetencao.show(true, item)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            Editar
          </v-tooltip>
          <v-tooltip v-if="$ability.can('Deletar','Retencao')" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="deleteFaixaRetencao(item, index)"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            Deletar
          </v-tooltip>
        </template>
      </v-data-table>
      <DialogFormRetencao @updated="update($event)" ref="dialogFormRetencao" />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Retencao from "@/services/retencao";
export default {
  name: "TableRetencao",

  components: {
    DialogFormRetencao: () => import("./DialogFormRetencao.vue")
  },

  data() {
    return {
      headers: [
        { text: "Parâmetro", value: "apelido" },
        { text: "Papel", value: "papel" },
        { text: "Faixa 1", value: "faixaRetencao1" },
        { text: "Faixa 2", value: "faixaRetencao2" },
        { text: "Ações", value: "action", sortable: false, align: "center" }
      ],
      search: "",
      serviceRetencao: new Retencao()
    };
  },

  computed: {
    ...mapGetters("retencao", ["getRetencao"]),

    getDataTable() {
      return this.getRetencao || [];
    }
  },

  methods: {
    update(newRetencao) {
      let index = this.$refs.dataTable.items.findIndex(
        item => item.id === newRetencao[1]
      );
      this.$refs.dataTable.items[index].papel = newRetencao[0].papel;
      this.$refs.dataTable.items[index].faixaRetencao1 =
        newRetencao[0].faixaRetencao1;
      this.$refs.dataTable.items[index].faixaRetencao2 =
        newRetencao[0].faixaRetencao2;
    },

    async deleteFaixaRetencao(item, index) {
      try {
        await this.serviceRetencao.delete(item.id);
        this.$toast.success(`Faixa de retenção deletada com sucesso.`);
        this.$refs.dataTable.items.splice(index, 1);
      } catch (error) {
        this.$toast.error(error);
        console.error(error);
      }
    }
  }
};
</script>

<style></style>
